export const PULL_INTERVAL = 30000;
export const IDLING_INTERVAL = 120000;
export const FILTER = {
  BY_STATUS: 'history.filterBy.status',
  BY_DATE: 'history.filterBy.date',
};

export const ACTION = {
  TRACK_ORDER: 'history.actions.trackOrder',
  CANCEL_ORDER: 'history.actions.cancelOrder',
  VIEW_RECEIPT: 'history.actions.viewReceipt',
  BOOK_AGAIN: 'history.actions.bookAgain',
};

export const TABLE_LOCALE = {
  EMPTY_LIST: 'history.locale.emptyOrder',
  NO_RESULT: 'history.locale.emptySearchResult',
  NO_RESULT_BY_STATUS: 'history.locale.emptyStatusSearchResult',
  LOAD_FAIL: 'history.locale.loadFail',
};

export const ORDER_STATE = {
  ALL_STATUS: 'history.orderState.allStatus',
  ACTIVE_DELIVERY: 'history.orderState.activeDelivery',
  PICKING_UP: 'history.orderState.pickingUp',
  DROPPING_OFF: 'history.orderState.droppingOff',
  CANCELLED: 'history.orderState.canceled',
  COMPLETED: 'history.orderState.completed',
  FINDING_DRIVER: 'history.orderState.findingDriver',
  ORDER_PLACED: 'history.orderState.orderPlaced',
  SCHEDULED: 'history.orderState.scheduled',
  PENDING_DROP_OFF: 'history.orderState.pendingDropoff',
  NO_DRIVER: 'history.orderState.noDriver',
  REALLOCATED: 'history.orderState.reallocated',
  SCHEDULING: 'SCHEDULING',
  SENDER_CANCELLED: 'history.orderState.senderCancelled',
  DAX_CANCELLED: 'history.orderState.daxCancelled',
  OPERATOR_CANCELLED: 'history.orderState.operatorCancelled',
  // status returned from BE for ongoing MSD orders
  IN_PROGRESS: 'history.orderState.inProgress',
  PENDING_RETURN: 'history.orderState.pendingReturn',
  RETURNING: 'history.orderState.returning',
  RETURNED: 'history.orderState.returned',
};

export const DISABLE_DOWNLOAD_ORDER_STATE = [
  'PICKING_UP',
  'DROPPING_OFF',
  'SCHEDULED',
  'ACTIVE_DELIVERY',
];

export const CANCEL_MODAL = {
  NO: 'history.cancelModal.no',
  TITLE: 'history.cancelModal.title',
  YES: 'history.cancelModal.yes',
};

export const INSTRUCTION = {
  MAIN: 'history.instruction',
  BUTTON: 'history.instruction.button',
  TITLE: 'history.instruction.title',
  CLOSE_BUTTON: 'history.instruction.closeButton',
};
export const FAILED_CANCEL_MODAL = {
  TITLE: 'history.failedCancelModal.title',
  FIRST_SENTENCE: 'history.failedCancelModal.message.firstSentence',
  SECOND_SENTENCE: 'history.failedCancelModal.message.secondSentence',
  OK: 'history.failedCancelModal.ok',
};
export const EXCEL_TABLE_VALUE = {
  dateCreated: 'history.table.dateCreated',
  aboutSender: 'booking.aboutSender',
  aboutRecipient: 'booking.aboutRecipient',
  serviceType: 'history.table.serviceType',
  itemAmount: 'booking.fieldLabel.itemAmount',
  deliveryFee: 'history.table.deliveryFee',
  paymentMethod: 'booking.fieldLabel.paymentMethod',
  promo: 'history.table.promoCode',
  deliveryStatus: 'history.table.deliveryStatus',
  viewReceipt: 'history.actions.viewReceipt',
  '#': 'history.table.orderNo',
  trackingLink: 'history.table.trackingLink',
  aboutSenderDetails: 'history.table.senderLocationDetails',
  aboutReceiverDetails: 'history.table.receiverLocationDetails',
  orderID: 'history.table.orderID',
  deliveryInstruction: 'history.table.deliveryInstruction',
  senderName: 'booking.fieldLabel.senderName',
  senderMobileNumber: 'booking.fieldLabel.senderMobileNumber',
  senderAddress: 'booking.fieldLabel.senderAddress',
  recipientName: 'booking.fieldLabel.recipientName',
  recipientMobileNumber: 'booking.fieldLabel.recipientMobileNumber',
  recipientAddress: 'booking.fieldLabel.recipientAddress',
  bookingID: 'history.table.bookingID',
  scheduledTime: 'history.table.scheduledTime',
  pickUpTime: 'history.table.pickUpTime',
  deliveredTime: 'history.table.deliveredTime',
  cancelledTime: 'history.table.cancelledTime',
  preDiscounted: 'history.table.preDiscounted',
  postDiscounted: 'history.table.postDiscounted',
  discountAmount: 'history.table.discountAmount',
  driverDetails: 'history.table.driverDetails',
  referenceCode: 'history.table.referenceCode',
};

export const SEARCH_BY = {
  FILTER: 'FILTER',
  STATUS: 'STATUS',
};

export const DELIVERY_STATUS_MAP = {
  COMPLETED: ORDER_STATE.COMPLETED,
  ORDER_PLACED: ORDER_STATE.ORDER_PLACED,
  SCHEDULED: ORDER_STATE.SCHEDULED,
  ALLOCATING: ORDER_STATE.SCHEDULED,
  PENDING_PICK_UP: ORDER_STATE.SCHEDULED,
  CANCELLED: ORDER_STATE.CANCELLED,
  DRIVER_NOT_FOUND: ORDER_STATE.NO_DRIVER,
  UNALLOCATED: ORDER_STATE.NO_DRIVER,
  NO_DRIVER: ORDER_STATE.NO_DRIVER,
  PICKING_UP: ORDER_STATE.PICKING_UP,
  DROPPING_OFF: ORDER_STATE.DROPPING_OFF,
  PENDING_DROP_OFF: ORDER_STATE.PENDING_DROP_OFF,
  REALLOCATED: ORDER_STATE.REALLOCATED,
  SENDER_CANCELLED: ORDER_STATE.SENDER_CANCELLED,
  DRIVER_CANCELLED: ORDER_STATE.DAX_CANCELLED,
  OPERATOR_CANCELLED: ORDER_STATE.OPERATOR_CANCELLED,
  MSD_ONGOING: ORDER_STATE.IN_PROGRESS,
  // status returned from BE for ongoing MSD orders
  UNKNOWN: ORDER_STATE.IN_PROGRESS,
  PENDING_RETURN: ORDER_STATE.PENDING_RETURN,
  RETURNING: ORDER_STATE.RETURNING,
  RETURNED: ORDER_STATE.RETURNED,
};

export const ACTIVE_DELIVERY_STATUS = [
  'SCHEDULED',
  'ALLOCATING',
  'PENDING_PICK_UP',
  'PICKING_UP',
  'PENDING_DROP_OFF',
  'DROPPING_OFF',
  // status returned from BE for ongoing MSD orders
  'UNKNOWN',
];

// https://jira.grab.com/browse/GFOM-6848
export const HIDE_ADDRESS_DELIVERY_STATUS = [
  'SENDER_CANCELLED',
  'DRIVER_CANCELLED',
  'OPERATOR_CANCELLED',
  'COMPLETED',
  'RETURNED',
];

export const IN_TRANSIT_DELIVERY_STATUS = [
  'SCHEDULED',
  'ALLOCATING',
  'PENDING_PICK_UP',
  'PICKING_UP',
  'PENDING_DROP_OFF',
  'DROPPING_OFF',
];

export const HISTORY_REPORT_TABLE_COLS = [
  ...'BCDEFGHIJKLMNOPQRSTUVWXYZ',
  'AA',
  'AB',
  'AC',
  'AD',
];

export const OLDEST_HISTORY_FETCH_DAYS = 92;

export const PAX_ORDER_HISTORY_FETCH_DAYS = 14;
export const GFB_ORDER_HISTORY_FETCH_DAYS = 10;

export const PAX_ORDER_HISTORY_INIT_FETCH_DAYS = 7;
export const GFB_ORDER_HISTORY_INIT_FETCH_DAYS = 3;

export const GFB_ORDER_SUMMARIZE_FETCH_DAYS = 1;
export const PAX_ORDER_SUMMARIZE_FETCH_DAYS = 7;

export const GFB_RECENT_BOOKINGS_FETCH_LIMIT = 10;
export const PAX_RECENT_BOOKINGS_FETCH_LIMIT = 40;

export const PAX_HISTORY_FETCH_LIMIT = 40;
